import api from './api'

const operations = {

    async massCopyProfileToOtherPremises(profileId,targetPremiseIds) {

        let results = {
            success : [],
            error   : []
        }

        if (targetPremiseIds.length == 0) {
            return;
        }

        for (let i=0;i<targetPremiseIds.length;i++) {
            let result = await api.profile.copyToOtherPremise(profileId,targetPremiseIds[i]);
            if (result.id) {
                results.success.push(result);
            } else {
                results.error.push(result)
            }
        }

        return results;

    },
    async getPremisesForProfileCopy(organizationId, sourcePremiseId) {

        let filteredPremises = [];

        const organization  = await api.organization.get(organizationId);
        const sourcePremise = await api.premise.get(sourcePremiseId);

        const allPremiseResult = await api.premise.search({
            organizationId : organizationId
        });

        const allPremises = allPremiseResult.list;

        allPremises.forEach((p) => {
            if (p.id != sourcePremiseId) {
                const isSamePremiseCadConfig =
                    (!p.cadConfigurationId && organization.cadConfigurationId) // organization has one configured, but premise does not
                    || ((!p.cadConfigurationId && !sourcePremise.cadConfigurationId) // they both don't have one configured
                    || (p.cadConfigurationId == 0 && sourcePremise.cadConfigurationId == 0) // they're both 0 (silly stupid triple check)
                    || (p.cadConfigurationId == sourcePremise.cadConfigurationId) // the premises match
                    || (p.cadConfigurationId == organization.cadConfigurationId)); // the target premise matches the org
                if (isSamePremiseCadConfig) {
                    let premiseName = `${p.name + (p.subName ? (' - ' + p.subName) : '')}`;
                    filteredPremises.push({
                        id: p.id,
                        name: premiseName
                    });
                }
            }
        });

        return filteredPremises;
    },

    async getUserProfileAndOrganization() {
        const userProfile = await api.userProfile.get();
        const primaryOrg = await this.getUserPrimaryOrganization(userProfile.id);
        return {
            user:userProfile,
            organization:primaryOrg
        }
    },

    async getUserPrimaryOrganization(userId) {
        let userOrganizations = await api.userOrganization.get(userId);
        const primaryOrg = userOrganizations.find(o=>o.primary);
        if (primaryOrg) {
            const org = await api.organization.get(primaryOrg.organizationId);
            return org;
        }
    }

}

export default operations;